import React from "react";
import ContactApple from "../Activity/ContactApple";

function Contact() {
  return (
    <div style={{marginTop:"10%"}}>
      Contact Apple
    </div>
  );
}

export default Contact;